"use client";

import { makeFunctionReference } from "convex/server";
import { useQuery } from "convex/react";
import type { OperationsAgenda as Agenda } from "@/core/console/agenda";
import { getDemoAgenda } from "@/lib/demo-data";
import { OperationsAgenda } from "./OperationsAgenda";

const getAgenda = makeFunctionReference<"query", { tenantId: string }, Agenda>(
  "agenda:getAgenda",
);

const CALM_REST: Agenda = {
  primaryFocus: { kind: "all_clear", activeCount: 0 },
  secondary: [],
  queuedCount: 0,
  watchingCount: 0,
  handledCount: 0,
};

export function OperationsAgendaClient({ tenantId }: { tenantId: string }) {
  if (!process.env.NEXT_PUBLIC_CONVEX_URL) {
    return <OperationsAgenda tenantId={tenantId} agenda={getDemoAgenda()} />;
  }
  return <LiveAgenda tenantId={tenantId} />;
}

function LiveAgenda({ tenantId }: { tenantId: string }) {
  const agenda = useQuery(getAgenda, { tenantId });
  if (agenda === undefined) {
    return (
      <div className="mx-auto flex max-w-3xl flex-col gap-6 px-6 py-16">
        <div className="h-40 animate-pulse rounded-xl bg-muted" />
        <div className="h-4 w-1/3 animate-pulse rounded bg-muted" />
      </div>
    );
  }
  return <OperationsAgenda tenantId={tenantId} agenda={agenda ?? CALM_REST} />;
}
